// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"1e48b713","249":"2789eae3","330":"0f8b26e3","395":"b1cbee7e","429":"c9a80e8f","453":"677141e8","489":"9c2263fc","634":"ef4bbba6"}[chunkId] + ".chunk.js";
};